import React from "react";
import { Crown } from "lucide-react";
import { useLang } from "@/context/LangContext";
import FOUNDER_TR from "@/i18n_founder";

/**
 * FounderBadge — small gold pill that marks an official Tigik News post
 * authored by Sauberino (the founder / admin).
 * Sizes: "xs" (chat inline) | "sm" (default) | "md" (post header)
 */
export default function FounderBadge({ size = "sm" }) {
  const { lang } = useLang() || { lang: "sk" };
  const t = FOUNDER_TR[lang] || FOUNDER_TR.sk;

  const sizing =
    size === "xs"
      ? "text-[9px] px-1.5 py-0.5 gap-1"
      : size === "md"
      ? "text-[11px] px-2.5 py-1 gap-1.5"
      : "text-[10px] px-2 py-0.5 gap-1";
  const iconSize =
    size === "xs" ? "w-2.5 h-2.5" : size === "md" ? "w-3.5 h-3.5" : "w-3 h-3";

  return (
    <span
      data-testid="founder-badge"
      title={t.tooltip}
      className={`inline-flex items-center font-mono uppercase tracking-wider font-bold bg-gradient-to-r from-amber-500 via-gold-400 to-amber-500 text-black border border-amber-700/60 shadow-sm ${sizing}`}
    >
      <Crown className={`${iconSize}`} strokeWidth={2.5} />
      {t.label} · {t.sub}
    </span>
  );
}
